export const getThemeFormFieldsKeySet = (key) => {
  switch (key) {
    case 'all':
      return [
        'search',
        'text',
        'textarea',
        'email',
        'number',
        'slider',
        'url',
        'date',
        'time',
        'datetime',
        'checkbox',
        'switch',
        'radio',
        'select',
        'multiSelect',
        'buttongroup',
        'lookup',
        'fileupload',
        'signature',
        'richtextarea',
        'currency',
        'daterange',
        'dropdown',
        'addressFinder',
        'externalLookup',
        'counter',
      ]
    case 'addressFinder':
      return ['addressFinder']
    case 'externalLookup':
      return ['externalLookup']
    case 'daterange':
      return ['daterange']
    case 'richtextarea':
      return ['richtextarea']
    case 'text':
      return ['text']
    case 'textarea':
      return ['textarea']
    case 'email':
      return ['email']
    case 'number':
      return ['number']
    case 'counter':
      return ['counter']
    case 'phone':
      return ['phone']
    case 'slider':
      return ['slider']
    case 'url':
      return ['url']
    case 'date':
      return ['date']
    case 'time':
      return ['time']
    case 'datetime':
      return ['datetime']
    case 'checkbox':
      return ['checkbox']
    case 'switcher':
      return ['switch']
    case 'radio':
      return ['radio']
    case 'dropdown':
      return ['select']
    case 'multiSelect':
      return ['multiSelect']
    case 'select':
      return ['select']
    case 'buttongroup':
      return ['buttongroup']
    case 'lookup':
      return ['lookup']
    case 'upload':
      return ['fileupload']
    case 'search':
      return ['search']
    case 'signature':
      return ['signature']
    case 'currency':
      return ['currency']
    default:
      return []
  }
}
